import { createI18n } from 'react-router-i18n';

// Array of supported locales
// The first in the array is treated as the default locale
const locales = ['en', 'jp', 'ar'];

// Dictionary of translations
const translations = {
  en: {
    general:{
      back:`BACK`,
      legalUrl:`https://www.thenissannext.com/legal.html`,
      eventSelectorUrl:`https://www.thenissannext.com/en/event-selector.html`,
    },
    partnership:{
      subheadline:`Nissan's Forward-looking Vision`,
      headline:`Expo 2020 Dubai Special Content`,
      text:`Nissan is proud to be the Official Automotive Partner of Expo 2020 Dubai. It's a testament to our shared vision as we shape the future of mobility, while enriching lives by tackling environmental and societal challenges through innovation. We've provided over 600 of our latest vehicles to give the anticipated 25 million visitors a glimpse into our next mobility chapter—one that is shaped by our Nissan Intelligent Mobility technology. The Expo provides a platform to engage in expert discussions and thought-provoking debates focused on sustainable transportation and smart-city development. Expo 2020 Dubai visitors can experience Nissan's tech-forward brand through engaging digital activations, involving exclusive videos, an opportunity to join our carbon-neutral goal and an interactive game throughout the six-month international fair.`,
      ctaText:`Explore the Experience`,
      ctaExternalLinkText:`Discover Nissan in your country`,
    },
    pillar:{
      title:`Expo 2020 Dubai Special Content`,
      headline:`See Our Latest in Action`,
      text:`Take in the sights and sounds that only Nissan's power and performance provide through live stream and on-demand videos of our latest vehicles. `,
      comingSoonText:``,
      ctaText:`EXPLORE`,
      ctaUrl:``,
      prevNav:`DISCOVER`,
      nextNav:`EXPERIENCE`
    },
    sakura:{
      title:'EXPO 2020 DUBAI SPECIAL CONTENT',
      headline:'Carbon-Neutral Goal',
      text:'Nissan is driven to create a carbon-neutral society. Help us accelerate the global effort towards climate change by writing a personal message of hope on our origami. These messages will populate our Sakura tree and provide promise for the future.',
      comingSoonText:``,
      ctaText:`DISCOVER`,
      ctaUrl:``,
      prevNav:`EXPERIENCE`,
      nextNav:`EXPLORE`
    },
    car:{
      title:'EXPO 2020 DUBAI SPECIAL CONTENT',
      headline:'Play with the Future of Mobility',
      text:`Step inside one of our vehicles and experience Nissan’s integrated technology and power. Nissan’s Intelligent Mobility features, like e-4ORCE and ProPILOT 2.0, offer assistance as you master various driving conditions.`,
      comingSoonText:``,
      ctaText:`EXPERIENCE THE ARIYA`,
      ctaUrl:`https://www.thenissannext.com/en/ariya.html`,
      //ctaUrl:``,
      prevNav:`EXPLORE`,
      nextNav:`DISCOVER`,
      videoInstructions:`Use arrow keys or swipe`
    },
    origami:{
      subheadline:`EXPO 2020 DUBAI SPECIAL CONTENT`,
      headline:`Carbon-Neutral Goal`,
      body:{
        line1:`At Expo 2020 Dubai, Nissan is telling the story of how tech innovation enhances the quality of life for all, in the brand’s quest to reach carbon neutrality by 2050 across all its operations, and the lifestyle of its products.`,
        line2:`Help us move closer to our goal by pairing a message of hope with a personalized origami. `,
        line3:`Together, we can make a difference and see how beautiful collective change can be.  `,
      },
      colorSelector:`SELECT COLOR`,
      patternSelector:`SELECT PATTERN`,
      flipCta:`FLIP PAPER`,
      sendCta:`SEND ORIGAMI`,
      shareHeadline:`Share or Download`,
      viewGallery:`VIEW GALLERY`,
      viewMessage:`VIEW MESSAGE`,
      hideMessage:`HIDE MESSAGE`,
      selectMessage:`SELECT MESSAGE`,
      selectMessageDesc:`Set a goal by choosing one of the messages to go on your personalized origami.`,
      exploreNissan: {
        title: 'DISCOVER NISSAN IN YOUR COUNTRY',
        url: ''
      },
      message1:{
          copyUser:`I'd like to reduce my household's amount of waste each week by recycling all my plastic items. It's a great way to conserve non-renewable fossil fuels.`,
          copyNissan:`Nissan's long-term vision for sustainability reduces dependency on new materials by 70%.`,
          copyUserLine1:`I'd like to reduce my household's amount of waste each week by recycling all my plastic items.`,
          copyUserLine2:`It's a great way to conserve non-renewable fossil fuels.`,
          copyNissanLine1:`Nissan's long-term vision for sustainability reduces dependency on new materials by 70%.`,
          copyNissanLine2:``,
      },
      message2:{
        copyUser:`I'd like to help reduce carbon emissions by flying less for work trips. Increasing my use of video-conferencing tools can reduce the need for long-distance work trips.`,
        copyNissan:`Nissan reduced CO₂ emissions globally from corporate activities by 33.7% per vehicle sold in FY2020 vs FY2005. `,
        copyUserLine1:`I'd like to help reduce carbon emissions by flying less for work trips.`,
        copyUserLine2:`Increasing my use of video-conferencing tools can reduce the need for long-distance work trips.`,
        copyNissanLine1:`Nissan reduced CO₂ emissions globally from corporate activities by 33.7% per vehicle sold in FY2020 vs FY2005.`,
        copyNissanLine2:``,
      },
      message3:{
        copyUser:`I'd like to reduce my home's carbon footprint by reducing air leaks and drafts. Taking care of this can reduce my home's CO₂ emissions and electricity consumption over time. `,
        copyNissan:`Nissan reduced CO₂ emissions globally at manufacturing sites by nearly 30% per vehicle produced in FY2020 vs FY2005. `,
        copyUserLine1:`I'd like to reduce my home's carbon footprint by reducing air leaks and drafts. `,
        copyUserLine2:`Taking care of this can reduce my home's CO₂ emissions and electricity consumption over time. `,
        copyNissanLine1:`Nissan reduced CO₂ emissions globally at manufacturing sites by nearly 30% per vehicle produced in FY2020 vs FY2005.`,
        copyNissanLine2:``,
      },
      message4:{
        copyUser:`One way I can reduce my home's carbon emissions is by installing solar panels. Over time, this renewable energy will save me money on electric bills while limiting my impact on the environment.`,
        copyNissan:`Nissan's global headquarters is one of Japan's greenest office buildings thanks to various commitments like using renewable energy and water recycling. `,
        copyUserLine1:`One way I can reduce my home's carbon emissions is by installing solar panels. `,
        copyUserLine2:`Over time, this renewable energy will save me money on electric bills while limiting my impact on the environment.`,
        copyNissanLine1:`Nissan's global headquarters is one of Japan's greenest office buildings thanks to various commitments like using renewable energy and water recycling. `,
        copyNissanLine2:``,
      },
      message5:{
        copyUser:`I can reduce my home's CO₂ emissions by simply turning lights off when I'm not using them. Compact fluorescent and LED bulbs also increase efficiency, leading to less emissions.`,
        copyNissan:`Nissan dealers in Japan have reduced their CO₂ emissions 19% vs FY2010.`,
        copyUserLine1:`I can reduce my home's CO₂ emissions by simply turning lights off when I'm not using them.`,
        copyUserLine2:`Compact fluorescent and LED bulbs also increase efficiency, leading to less emissions.`,
        copyNissanLine1:`Nissan dealers in Japan have reduced their CO₂ emissions 19% vs FY2010.`,
        copyNissanLine2:``,
      },
      message6:{
        copyUser:`I'd like to focus more on recycling batteries. As batteries break down in landfills, they start to leak chemicals into the soil and possibly the ocean, so recycling them is important. `,
        copyNissan:`Our Nissan EV Ecosystem is constantly developing new ways to reuse our lithium-ion batteries after their first life powering an EV.`,
        copyUserLine1:`I'd like to focus more on recycling batteries.`,
        copyUserLine2:`As batteries break down in landfills, they start to leak chemicals into the soil and possibly the ocean, so recycling them is important.`,
        copyNissanLine1:`Our Nissan EV Ecosystem is constantly developing new ways to reuse our lithium-ion batteries after their first life powering an EV. `,
        copyNissanLine2:``,
      },
      message7:{
        copyUser:`I'd like to ensure major appliances like my washing machine and refrigerator are eco-friendly. My impact on the environment decreases by upgrading to high-efficiency appliances.`,
        copyNissan:`Nissan's goal is to have its all-new vehicles electrified in key markets by the early 2030s. `,
        copyUserLine1:`I'd like to ensure major appliances like my washing machine and refrigerator are eco-friendly.`,
        copyUserLine2:`My impact on the environment decreases by upgrading to high-efficiency appliances.`,
        copyNissanLine1:`Nissan's goal is to have its all-new vehicles electrified in key markets by the early 2030s. `,
        copyNissanLine2:``,
      },
      message8:{
        copyUser:`I'd like to make a better effort to recycle more materials. Recycling centers can even handle items my city can't. This decreases pollution by reducing the need to collect new raw materials. `,
        copyNissan:`Nissan focuses on closed-loop recycling of steel, aluminum and resin, which are key materials of vehicle content but also have a major impact on the environment.`,
        copyUserLine1:`I'd like to make a better effort to recycle more materials. Recycling centers can even handle items my city can't. `,
        copyUserLine2:`This decreases pollution by reducing the need to collect new raw materials. `,
        copyNissanLine1:`Nissan focuses on closed-loop recycling of steel, aluminum and resin, which are key materials of vehicle content but also have a major impact on the environment.`,
        copyNissanLine2:``,
      },
      message9:{
        copyUser:`I'd like to increase the air quality in my home by limiting my exposure to Volatile Organic Compounds (VOCs), chemicals that are in many products we use to build and maintain our homes. I'll look to buy more low-VOC options of paints and furnishings in the future.`,
        copyNissan:`Nissan's manufacturing process is introducing water-based paint lines that emit fewer VOCs* and improve thinner-solvent recycling rates to reduce our use of VOC-emitting substances. *VOCs: Organic chemicals that readily evaporate and become gaseous at normal temperature and pressure conditions.`,
        copyUserLine1:`I'd like to increase the air quality in my home by limiting my exposure to Volatile Organic Compounds (VOCs), chemicals that are in many products we use to build and maintain our homes.`,
        copyUserLine2:`I'll look to buy more low-VOC options of paints and furnishings in the future.`,
        copyNissanLine1:`Nissan's manufacturing process is introducing water-based paint lines that emit fewer VOCs* and improve thinner-solvent recycling rates to reduce our use of VOC-emitting substances. `,
        copyNissanLine2:`*VOCs: Organic chemicals that readily evaporate and become gaseous at normal temperature and pressure conditions.`,
      },
      message10:{
        copyUser:`I'd like to reduce my household's impact on our landfill. A few ways I can do this is by donating old clothes instead of throwing them away, buying items with less packaging and purchasing items made from recycled products.`,
        copyNissan:`Nissan reduced its waste to landfill ratio to 3.4% globally in FY2020.`,
        copyUserLine1:`I'd like to reduce my household's impact on our landfill.`,
        copyUserLine2:`A few ways I can do this is by donating old clothes instead of throwing them away, buying items with less packaging and purchasing items made from recycled products.`,
        copyNissanLine1:`Nissan reduced its waste to landfill ratio to 3.4% globally in FY2020.`,
        copyNissanLine2:``,
      },
      pattern1: {
        description:`Resembles the forward-moving feathers of an arrow; represents good luck for everyone.`,
      },
      pattern2: {
        description:`Symbolizes how short and beautiful life can be; the cherry blossom is a symbol of new beginnings.`,
      },
      pattern3: {
        description:`A hexagon-based pattern that resembles a hemp leaf; represents growth because hemp is durable and grows quickly.`,
      },
      pattern4: {
        description:`Inspired by design found throughout the ARIYA.`,
      },
      pattern5: {
        description:`Based on design elements of the new Z, this geometric pattern takes a tech-forward approach.`,
      },
      pattern6:{
        description:`Inspired by a core design element from the Nissan Futures event, its structure and varying weights convey a subtle rhythm.`
      },
      share:{
        facebook:`We aim to impact you, not the environment. We've reduced our carbon footprint in pursuit of our long-term goal of carbon neutrality. Create your goal to help counter climate change and watch it blossom on. #Nissan #Expo2020 #OrigamiOfHope`,
        twitter:`Create your carbon-neutral goal and watch it blossom.`
      },
    },
    ariya:{
      share:{
        twitter:`Enjoy an electrifying ride with the Nissan ARIYA. #Nissan #Expo2020 #PowerAtPlay`,
        title:`ARIYA at Play`,
        desc:`Charge ahead with an electrifying ride in the Nissan ARIYA. Enjoy high-tech and low-stress driving as you conquer various road conditions, making your journey safer and easier with driver assist technologies. #Nissan #Expo2020 #PowerAtPlay`,
      }
    }
  },
  jp: {
    general:{
      back:`戻る`,
      legalUrl:`https://www.thenissannext.com/jlegal.html`,
      eventSelectorUrl:`https://www.thenissannext.com/jp/event-selector.html`
    },
    partnership:{
      subheadline:`未来に向けた日産のビジョン`,
      headline:`2020年ドバイ国際博覧会 スペシャルコンテンツ`,
      text:`日産は、2020年ドバイ国際博覧会のオフィシャルパートナーとして、環境や社会の問題にイノベーションを通じて取り組み、人々の生活を豊かにするというビジョンを伝えていきます。      「ニッサン インテリジェント モビリティ」の技術により形作られるモビリティの未来を、2500万人とも予想される来場者の方々へ伝えるため、日産は600台以上の最新車両を2020年ドバイ国際博覧会へ提供します。      当ウェブサイトでは、様々な形でのデジタル体験を通して、日産の将来を見据えたテクノロジーやブランドを体験することができるコンテンツを順次公開予定です。`,
      ctaText:`コンテンツを見る`,
      ctaExternalLinkText:`日産自動車株式会社 オフィシャルWEBサイトを見る`,
    },
    pillar:{
      title:`2020年ドバイ国際博覧会 スペシャルコンテンツ`,
      headline:`最新情報を見る`,
      text:`ライブストリームや最新車両についての映像を通じて、日産のテクノロジーやブランドを体感することができます。`,
      comingSoonText:``,
      ctaText:`コンテンツを見る`,
      ctaUrl:``,
      prevNav:` 持続可能な社会へ`,
      nextNav:`先進技術を体験`
    },
    sakura:{
      title:'2020年ドバイ国際博覧会 スペシャルコンテンツ',
      headline:'カーボンニュートラルの実現をめざして',
      text:'日産は、カーボンニュートラルな社会の実現を目指しています。希望のメッセージを折り紙に託し、気候変動に対する世界的な取り組みを加速させましょう。桜の花に込められたメッセージは、未来への約束となるはずです。',
      comingSoonText:``,
      ctaText:`折り紙に思いを託す`,
      ctaUrl:``,
      prevNav:`先進技術を体験`,
      nextNav:`最新情報`
    },
    car:{
      // title:'近日公開予定',
      title:'2020年ドバイ国際博覧会 スペシャルコンテンツ',
      headline:'将来のモビリティでプレイ ',
      text:'日産の最新EVに乗り込み、さまざまな走行条件をクリアしていくインタラクティブなゲームです。ゲームを通して、日産の先進機能を体験します。',
      comingSoonText:``,
      ctaText:`日産 アリアを体験`,
      ctaUrl:`https://www3.nissan.co.jp/vehicles/new/ariya.html`,
      prevNav:`最新情報`,
      nextNav:` 持続可能な社会へ`,
      videoInstructions:`矢印キーまたは指で左右にスワイプします。`
    },
    origami:{
      subheadline:`2020年ドバイ国際博覧会 スペシャルコンテンツ`,
      headline:`カーボンニュートラルの実現をめざして`,
      body:{
        line1:`2020年ドバイ国際博覧会で日産は、技術革新を通してどのように人々の生活をより豊かにし、2050年までのカーボンニュートラル実現に向けて取り組んでいくかを伝えています。`,
        line2:`この目標の実現に向けて、あなたの希望のメッセージをオリジナルの折り紙に託し、日産と共に環境を守る行動を起こしましょう。`,
        line3:`皆で力を合わせれば、違いが生まれ、パワフルで美しい変化をもたらすことができるでしょう。  `,
      },
      colorSelector:`色を選択`,
      patternSelector:`パターンを選択`,
      flipCta:`紙を裏返す`,
      sendCta:`折り紙を送る`,
      shareHeadline:`シェアまたはダウンロードする`,
      viewGallery:`ギャラリーを見る`,
      viewMessage:`メッセージを見る`,
      hideMessage:`メッセージを隠す`,
      selectMessage:`メッセージを選択`,
      selectMessageDesc:`メッセージの中から、オリジナルの折り紙に載せる目標を選んでください。`,
      exploreNissan: {
        title: '日産自動車株式会社 オフィシャルWEBサイトを見る',
        url: 'https://www.nissan.co.jp/'
      },
      message1:{
          copyUser:`さまざまなプラスチック製品をリサイクルすることで、家から出るごみの量を毎週減らしていきます。再生不可能な化石燃料の消費を抑えることができます。`,
          copyNissan:`日産の環境への取り組みとして、新規採掘資源に頼らない材料を70%に低減することを長期ビジョンとしています。`,
          copyUserLine1:`埋立処分される家庭ごみの量を減らします。そのためには、古い服を捨てずに寄付したり、`,
          copyUserLine2:`梱包材が少ない商品、リサイクルした素材を使った商品を積極的に選びます。`,
          copyNissanLine1:`日産は工場からの 廃棄物埋め立て量 を2020年度に全体で3.4%まで削減することができました。`,
          copyNissanLine2:``,
      },
      message2:{
        copyUser:`出張に飛行機を使う回数を減らすことで、二酸化炭素排出量の削減に貢献します。ビデオ会議ツールを活用すれば、長距離出張を減らすことができます。`,
        copyNissan:`日産は企業活動全体からのCO₂排出量を2020年度では33.7％削減することができました。(2005年度比）`,
        copyUserLine1:`出張に飛行機を使う回数を減らすことで、二酸化炭素排出量の削減に貢献します。`,
        copyUserLine2:`ビデオ会議ツールを活用すれば、長距離出張を減らすことができます。`,
        copyNissanLine1:`日産は企業活動全体からのCO₂排出量を2020年度では33.7％削減することができました。（2005年度比）`,
        copyNissanLine2:``,
      },
      message3:{
        copyUser:`空気の漏れやすきま風を減らすことで、家の二酸化炭素排出量を減らします。このような対策は、長期的に家から出るCO₂排出量と電力消費を削減できます。`,
        copyNissan:`日産は生産活動でのCO₂排出量を2020年度では30％近く削減しました。（2005年度比）`,
        copyUserLine1:`空気の漏れやすきま風を減らすことで、家の二酸化炭素排出量を減らします。`,
        copyUserLine2:`このような対策は、長期的に家から出るCO₂排出量と電力消費を削減できます。`,
        copyNissanLine1:`日産は生産活動でのCO₂排出量を2020年度では30％近く削減しました。（2005年度比）`,
        copyNissanLine2:``,
      },
      message4:{
        copyUser:`家から出る二酸化炭素排出量の削減方法として、ソーラーパネルの設置を考えています。再生可能エネルギーを使うことで、長期的に環境への影響を抑えると同時に電気代の節約にもなります。`,
        copyNissan:`日産のグローバル本社ビルは、自然エネルギーの有効活用とCO₂排出量の削減、水のリサイクル、廃棄物の大幅な削減が評価され、日本最高レベルの環境性能を持つオフィスビルとして認証されました。`,
        copyUserLine1:`家から出る二酸化炭素排出量の削減方法として、ソーラーパネルの設置を考えています。`,
        copyUserLine2:`再生可能エネルギーを使うことで、長期的に環境への影響を抑えると同時に電気代の節約にもなります。`,
        copyNissanLine1:`日産のグローバル本社ビルは、自然エネルギーの有効活用とCO₂排出量の削減、 水のリサイクル、廃棄物の大幅な削減が評価され、日本最高レベルの環境性能を 持つオフィスビルとして認証されました。`,
        copyNissanLine2:``,
      },
      message5:{
        copyUser:`使用していない電気を消すことで、家から出るCO₂排出量を減らすことができます。小型の蛍光灯やLED電球もエネルギー効率を高め、CO₂排出量の削減につながります。`,
        copyNissan:`日産の国内販売店でのCO₂排出量を2020年度では19％削減することができました。（2010年度比）`,
        copyUserLine1:`使用していない電気を消すことで、家から出るCO₂排出量を減らすことができます。`,
        copyUserLine2:`小型の蛍光灯やLED電球もエネルギー効率を高め、CO₂排出量の削減につながります。`,
        copyNissanLine1:`日産の国内販売店での CO₂排出量を2020年度では19％削減することができました。（2010年度比）`,
        copyNissanLine2:``,
      },
      message6:{
        copyUser:`電池のリサイクルにもっと力を入れたいと思います。埋立地で電池の分解が進むと化学物質が土壌や場合によっては海に漏れ出すため、電池をリサイクルすることは大切です。`,
        copyNissan:`日産はEVエコシステムを構築するべく、EV向けバッテリーの研究開発やバッテリーの二次利用やリサイクルなどの取り組みを進めています。`,
        copyUserLine1:`電池のリサイクルにもっと力を入れたいと思います。`,
        copyUserLine2:`埋立地で電池の分解が進むと化学物質が土壌や場合によっては海に漏れ出すため、電池をリサイクルすることは大切です。`,
        copyNissanLine1:`日産はEVエコシステムを構築するべく、EV向けバッテリーの研究開発やバッテリーの二次利用やリサイクルなどの取り組みを進めています。`,
        copyNissanLine2:``,
      },
      message7:{
        copyUser:`環境に優しい、洗濯機や冷蔵庫などの生活家電を使用します。エネルギー効率の高い家電製品に買い替えることで、環境への影響を減らすことができます。`,
        copyNissan:`日産は2030年代早期より、主要市場に投入する新型車をすべて電動車両とすることを目指しています。`,
        copyUserLine1:`環境に優しい、洗濯機や冷蔵庫などの生活家電を使用します。`,
        copyUserLine2:`エネルギー効率の高い家電製品に買い替えることで、環境への影響を減らすことができます。`,
        copyNissanLine1:`日産は2030年代早期より、主要市場に投入する新型車をすべて電動車両とすることを目指しています。`,
        copyNissanLine2:``,
      },
      message8:{
        copyUser:`より多くのものをリサイクルできるよう、さらに努力したいと思います。リサイクルを通して、原料を新たに採取する必要性が減り、環境汚染を防ぐことにつながります。`,
        copyNissan:`日産はクルマの材料として占める割合が高く、環境への影響が高い鉄、アルミニウム、樹脂という3つの材料のクローズド・ループリサイクルに取り組んでいます。`,
        copyUserLine1:`より多くのものをリサイクルできるよう、さらに努力したいと思います。`,
        copyUserLine2:`リサイクルを通して、原料を新たに採取する必要性が減り、環境汚染を防ぐことにつながります。`,
        copyNissanLine1:`日産はクルマの材料として占める割合が高く、環境への影響が高い鉄、アルミニウム、樹脂という3つの材料のクローズド・ループリサイクルに取り組んでいます。`,
        copyNissanLine2:``,
      },
      message9:{
        copyUser:`揮発性有機化合物（VOC）の使用を抑えることで、家の中の空気の質を改善します。この化学物質は、家の建設や補修に使用される製品の多くに含まれています。今後は、VOC含有量の低いペンキや家具を購入したいと思います。`,
        copyNissan:`日産の生産過程では、VOC*の少ない水系塗装ラインへの切り替えや廃シンナーのリサイクル率向上を進め、VOCの使用量そのものの削減に取り組んでいます。*VOC:Volatile Organic Compoundsの略。揮発性を有し、常温・常圧で気体状となる有機化合物の総称。`,
        copyUserLine1:`揮発性有機化合物（VOC）の使用を抑えることで、家の中の空気の質を改善します。この化学物質は、家の建設や補修に使用される製品の多くに含まれています。`,
        copyUserLine2:`今後は、VOC含有量の低いペンキや家具を購入したいと思います。`,
        copyNissanLine1:`日産の生産過程では、VOC* の少ない水系塗装ラインへの切り替えや廃シンナーのリサイクル率向上を進め、VOCの使用量そのものの削減に取り組んでいます。`,
        copyNissanLine2:`*VOC:Volatile Organic Compoundsの略。揮発性を有し、常温・常圧で気体状となる有機化合物の総称。`,
      },
      message10:{
        copyUser:`埋立処分される家庭ごみの量を減らします。そのためには、古い服を捨てずに寄付したり、梱包材が少ない商品、リサイクルした素材を使った商品を積極的に選びます。`,
        copyNissan:`日産は工場からの廃棄物埋め立て量を2020年度に全体で3.4%まで削減することができました。`,
        copyUserLine1:`埋立処分される家庭ごみの量を減らします。`,
        copyUserLine2:`そのためには、古い服を捨てずに寄付したり、梱包材が少ない商品、リサイクルした素材を使った商品を積極的に選びます。`,
        copyNissanLine1:`日産は工場からの 廃棄物埋め立て量 を2020年度に全体で3.4%まで削減することができました。`,
        copyNissanLine2:``,
      },
      pattern1: {
        description:`前に向かって飛ぶ矢の羽根をイメージし、すべての人に幸運をもたらすことを表現しています。`,
      },
      pattern2: {
        description:`儚くも美しい人生を象徴しています。桜の花は新たな始まりのシンボルです。`,
      },
      pattern3: {
        description:`六角形の模様が麻の葉を表しています。麻は丈夫で早く伸びるため、成長を意味します。`,
      },
      pattern4: {
        description:`アリアの各所に施されたデザインにインスパイアされています。`,
      },
      pattern5: {
        description:`新型「Z」のデザインを基調とした幾何学模様です。先進的なテクノロジーを追求する姿勢を示しています。`,
      },
      pattern6:{
        description:`Nissan Futures イベントのコアデザインからインスピレーションを得た模様です。構図やビジュアルウェイトにバリエーションを与えることで巧みなリズムを創り出しています。`
      },
      share:{
        facebook:`日産はカーボンニュートラルの実現に向けて、様々な取り組みを行なっています。ぜひ日産と共に、環境を守る第一歩を踏み出してみませんか。あなたの立てた目標が折り紙の花を咲かせます。#Nissan #Expo2020 #OrigamiOfHope`,
        twitter:`ぜひ日産と共に、環境を守る第一歩を踏み出してみませんか。あなたの立てた目標が折り紙の花を咲かせます。 `
      },
    },
    ariya:{
      share:{
        twitter:`日産アリアで爽快なドライブの旅に出かけよう！#Nissan #Expo2020 #PowerAtPlay`,
        title:`日産アリアを体験`,
        desc:`日産アリアで爽快なドライブの旅に出かけよう！どんな状況でもより快適に、ワクワクするドライビングをお楽しみいただくために、日産の先進技術があなたのドライブをサポートします。 #Nissan #Expo2020 #PowerAtPlay`,
      }
    }
  },
  ar:{
    general:{
      back:`رجوع`,
      legalUrl:`https://www.thenissannext.com/arlegal.html`,
      eventSelectorUrl:`https://www.thenissannext.com/ar/event-selector.html`
    },
    partnership:{
      subheadline:`رؤية نيسان المستقبلية`,
      headline:`محتوى خاص لإكسبو 2020 دبي`,
      text:`تفخر نيسان بكونها الشريك الرسمي في مجال السيارات في إكسبو 2020 دبي. إنها شهادة على رؤيتنا المشتركة في عملنا لرسم مستقبل التنقل، مع إثراء حياة البشر من خلال الابتكارات التي تعالج التحديات البيئية والمجتمعية. سنقدم أكثر من 600 سيارة من أحدث سياراتنا لمنح 25 مليون زائر متوقع لمحة عن الفصل القادم من مسيرتنا في مجال التنقل، وهو فصل تشكّله تقنية التنقل الذكي من نيسان. يوفر الإكسبو منصة للمشاركة في مناقشات الخبراء والحوارات المحفزة للفكر التي تتمحور حول النقل المستدام وتطوير المدن الذكية. يمكن لزوار إكسبو 2020 دبي تجربة علامة نيسان التجارية السبَّاقة تقنيًا من خلال عمليات التنشيط الرقمية التفاعلية، بما في ذلك مقاطع الفيديو الحصرية، وفرصة الانضمام إلى هدف تحقيق تعادل الأثر الكربوني، وممارسة لعبة تفاعلية طوال المعرض الدولي الذي يستمر لستة أشهر.`,
      ctaText:`استكشف التجربة`
    },
    pillar:{
      title:`محتوى خاص لإكسبو 2020 دبي`,
      headline:`شاهد كيف تعمل تقنياتنا`,
      text:`سيستمتع الزوار بالمشاهد والأصوات الصادرة عن قوة سيارة نيسان وأدائها من خلال البث الحي ومقاطع الفيديو عند الطلب لأحدث سياراتها.`,
      comingSoonText:``,
      ctaText:`استكشف`,
      ctaUrl:``,
      prevNav:`اختبر`,
      nextNav:` اكتشف`
    },
    sakura:{
      title:'محتوى خاص لإكسبو 2020 دبي ',
      headline:'هدف تحقيق تعادل الأثر الكربوني',
      text:'تُركّز نيسان على إنشاء مجتمع متعادل الأثر الكربوني. بادر بمساعدتنا على تسريع الجهود العالمية تجاه تغير المناخ من خلال كتابة رسالة شخصية مفعمة بالأمل على الأشكال الورقية الخاصة بنا. وستملأ هذه الرسائل شجرة ساكورا الخاصة بنا وتقدم وعدًا للمستقبل.',
      comingSoonText:``,
      ctaText:`اختبر`,
      ctaUrl:``,
      prevNav:` اكتشف`,
      nextNav:`استكشف`
    },
    car:{
      // title:'قريبا',
      title:'محتوى خاص لإكسبو 2020 دبي ',
      headline:'امرح وعِش مستقبل التنقل',
      text:'استقلّ إحدى سياراتنا وتعرَّف على تقنية نيسان وأدائها المتكاملين من خلال اللعبة التفاعلية متعددة المستويات التي تحاكي ظروف القيادة المختلفة. سنستخدم ميزات التنقل الذكي من نيسان، مثل e-4ORCE وProPILOT 2.0 لمساعدتك في التغلب على التحديات أثناء المنافسة من أجل الوصول إلى القمة.',
      comingSoonText:``,
      ctaText:`اختبر آريا`,
      ctaUrl:`https://www.thenissannext.com/en/ariya.html`,
      prevNav:`استكشف`,
      nextNav:`اختبر`,
      videoInstructions:`استخدم أزرار الأسهم أو اقلب`
    },
    origami:{
      subheadline:`محتوى خاص لإكسبو 2020 دبي `,
      headline:`هدف تحقيق حيادية الأثر الكربوني`,
      body:{
        line1:`تروي نيسان في إكسبو ٢٠٢٠، قصتها مع الابتكار التكنولوجي وكيف يعزّز جودة حياة البشر، ذلك في إطار سعيها إلى تحقيق الحياد الكربوني بحلول العام ٢٠٥٠ على امتداد كافة عملياتها التشغيلية والإنتاجية، إضافة إلى نمط حياة منتجاتها.`,
        line2:`الاقتراب أكثر من تحقيق هدفنا عبر الجمع بين رسالة أمل وأوريغامي مخصّصة.`,
        line3:`معًا، يمكننا أن نُحْدِث فرقًا ونرى كم رائعًا يمكن للتغيير الجماعي أن يكون.  `,
      },
      colorSelector:`اختيار اللون`,
      patternSelector:`اختيار النمط`,
      flipCta:`قلب الورقة`,
      sendCta:`إرسال أوريغامي`,
      shareHeadline:`مشاركة أو تنزيل`,
      viewGallery:`عرض معرض الصور`,
      viewMessage:`عرض الرسالة`,
      hideMessage:`إخفاء الرسالة`,
      selectMessage:`اختيار الرسالة `,
      selectMessageDesc:`حدّد هدفًا عبر اختيار إحدى الشعارات المذكورة أدناه لتصل إلى أوريغامي الخاصة بك.`,
      exploreNissan: {
        title: 'اكتشف نيسان في بلدك',
        url: 'https://www.nissan-me.com/'
      },
      message1:{
          copyUser:`أريد تخفيض كمية النفايات الناتجة عن منزلي أسبوعيًا عبر إعادة تدوير جميع أغراضي البلاستيكية. إنها طريقة رائعة للحفاظ على الوقود الأحفوري غير المتجدّد. `,
          copyNissan:`تساهم رؤية نيسان طويلة الأمد للاستدامة في تخفيض الاعتماد على المواد الجديدة بنسبة ٧٠٪.`,
          copyUserLine1:`أريد تخفيض كمية النفايات الناتجة عن منزلي أسبوعيًا عبر إعادة تدوير جميع أغراضي `,
          copyUserLine2:`البلاستيكية. إنها طريقة رائعة للحفاظ على الوقود الأحفوري غير المتجدّد. `,
          copyNissanLine1:`تساهم رؤية نيسان طويلة الأمد للاستدامة في تخفيض الاعتماد على المواد الجديدة بنسبة ٧٠٪.`,
          copyNissanLine2:``,
      },
      message2:{
        copyUser:`أرغب في تخفيض نسبة انبعاثات ثاني أكسيد الكربون عبر تقليل رحلات أعمالي الجوية. فالاعتماد أكثر على الفيديو كأداة لعقد المؤتمرات قد يقلّل الحاجة إلى رحلات العمل الطويلة والبعيدة.`,
        copyNissan:`ساهمت نيسان في خفض انبعاثات ثاني أكسيد الكربون على مستوى العالم من خلال مبيعاتها اليومية بنسبة ٣٣.٧٪ على كلّ سيارة تم بيعها في السنة المالية ٢٠٢٠ مقارنة بالسنة المالية ٢٠٠٥.`,
        copyUserLine1:`أرغب في تخفيض نسبة انبعاثات ثاني أكسيد الكربون عبر تقليل رحلات أعمالي الجوية.`,
        copyUserLine2:`فالاعتماد أكثر على الفيديو كأداة لعقد المؤتمرات قد يقلّل الحاجة إلى رحلات العمل الطويلة والبعيدة.`,
        copyNissanLine1:`ساهمت نيسان في خفض انبعاثات ثاني أكسيد الكربون على مستوى العالم من خلال مبيعاتها اليومية بنسبة ٣٣.٧٪ على كلّ سيارة تم بيعها في السنة المالية ٢٠٢٠ مقارنة بالسنة المالية ٢٠٠٥.`,
        copyNissanLine2:``,
      },
      message3:{
        copyUser:`أودّ الحدّ من البصمة الكربونية الناتجة عن استهلاكي المنزلي عبر تخفيض نسبة منافذ تسرّب الهواء والشقوق. فحلّ هذه المسألة ممكن أن يخفض انبعاثات ثاني أكسيد الكربون الناتجة عن منزلي، وكذلك استهلاك الكهرباء على مرّ الزمن.`,
        copyNissan:`ساهمت نيسان في خفض انبعاثات ثاني أكسيد الكربون على مستوى العالم في مواقع التصنيع بحوالي نسبة ٣٠٪ على كلّ سيارة تم تصنيعها في السنة المالية ٢٠٢٠ مقارنة بالسنة المالية ٢٠٠٥.`,
        copyUserLine1:`أودّ الحدّ من البصمة الكربونية الناتجة عن استهلاكي المنزلي عبر تخفيض نسبة منافذ تسرّب الهواء والشقوق.`,
        copyUserLine2:`فحلّ هذه المسألة ممكن أن يخفض انبعاثات ثاني أكسيد الكربون الناتجة عن منزلي، وكذلك استهلاك الكهرباء على مرّ الزمن.`,
        copyNissanLine1:`ساهمت نيسان في خفض انبعاثات ثاني أكسيد الكربون على مستوى العالم في مواقع التصنيع بحوالي نسبة ٣٠٪ على كلّ سيارة تم تصنيعها في السنة المالية ٢٠٢٠ مقارنة بالسنة المالية ٢٠٠٥.`,
        copyNissanLine2:``,
      },
      message4:{
        copyUser:`إنّ تركيب الألواح الشمسية هو إحدى الطرق للحدّ من انبعاثات ثاني أكسيد الكربون الناتجة عن استهلاكي المنزلي. فعلى المدى الطويل، ستقلّص هذه الطاقة المتجدّدة قيمة فواتيري الكهربائية مع الحدّ من تأثيرها على البيئة.`,
        copyNissan:`إنّ المقرّ الرئيسي العالمي لشركة نيسان هو أحد المباني الأكثر استدامة في اليابان بفضل استهلاكه للطاقة المتجددة وإعادة تدويره للمياه.`,
        copyUserLine1:`إنّ تركيب الألواح الشمسية هو إحدى الطرق للحدّ من انبعاثات ثاني أكسيد الكربون الناتجة عن استهلاكي المنزلي.`,
        copyUserLine2:`فعلى المدى الطويل، ستقلّص هذه الطاقة المتجدّدة قيمة فواتيري الكهربائية مع الحدّ من تأثيرها على البيئة.`,
        copyNissanLine1:`إنّ المقرّ الرئيسي العالمي لشركة نيسان هو أحد المباني الأكثر استدامة في اليابان بفضل استهلاكه للطاقة المتجددة وإعادة تدويره للمياه.`,
        copyNissanLine2:``,
      },
      message5:{
        copyUser:`بإمكاني خفض انبعاثات ثاني أكسيد الكربون من منزلي بمجرّد إطفاء الأضواء عند عدم الحاجة إليها. كما تساهم لمبات الفلورسنت أو المصابيح الفلورية في زيادة كفاءة استهلاك الطاقة ممّا يخفّض من تلك الانبعاثات.`,
        copyNissan:`نجح وكلاء نيسان في اليابان بتخفيض انبعاثات ثاني أكسيد الكربون بنسبة ١٩٪ مقارنة بالسنة المالية ٢٠١٠.`,
        copyUserLine1:`بإمكاني خفض انبعاثات ثاني أكسيد الكربون من منزلي بمجرّد إطفاء الأضواء عند عدم الحاجة إليها.`,
        copyUserLine2:`كما تساهم لمبات الفلورسنت أو المصابيح الفلورية في زيادة كفاءة استهلاك الطاقة ممّا يخفّض من تلك الانبعاثات.`,
        copyNissanLine1:`نجح وكلاء نيسان في اليابان بتخفيض انبعاثات ثاني أكسيد الكربون بنسبة ١٩٪ مقارنة بالسنة المالية ٢٠١٠.`,
        copyNissanLine2:``,
      },
      message6:{
        copyUser:`أريد التركيز أكثر على إعادة تدوير البطاريات. فعند تحلّلها في مطامر النفايات، تفرز البطاريات مواد كيميائية داخل التربة قد تصل إلى المحيط أيضًا، وبالتالي من المهم أي يُعاد تدويرها.`,
        copyNissan:`إنّ النظام البيئي لسيارات نيسان الكهربائية يطوّر باستمرار أساليب جديدة لإعادة استخدام بطاريات أيون الليثيوم بعد أوّل دورة شحن كاملة لسيارة كهربائية.`,
        copyUserLine1:`أريد التركيز أكثر على إعادة تدوير البطاريات.`,
        copyUserLine2:`فعند تحلّلها في مطامر النفايات، تفرز البطاريات مواد كيميائية داخل التربة قد تصل إلى المحيط أيضًا، وبالتالي من المهم أي يُعاد تدويرها.`,
        copyNissanLine1:`إنّ النظام البيئي لسيارات نيسان الكهربائية يطوّر باستمرار أساليب جديدة لإعادة استخدام بطاريات أيون الليثيوم بعد أوّل دورة شحن كاملة لسيارة كهربائية.`,
        copyNissanLine2:``,
      },
      message7:{
        copyUser:`أود التأكّد من أنّ غالبية الأجهزة في منزلي مثل الغسالة والثلاجة هي صديقة للبيئة. فالأثر السلبي على البيئة يكون أقل عبر استخدام أجهزة عالية الكفاءة من ناحية استخدام الطاقة.`,
        copyNissan:`تهدف نيسان إلى أن تكون كافة سياراتها الجديدة كليًا كهربائية في الأسواق الكبيرة بحلول العام ٢٠٣٠.`,
        copyUserLine1:`أود التأكّد من أنّ غالبية الأجهزة في منزلي مثل الغسالة والثلاجة هي صديقة للبيئة. فالأثر السلبي على البيئة يكون أقل عبر استخدام أجهزة عالية الكفاءة من ناحية استخدام الطاقة.`,
        copyUserLine2:``,
        copyNissanLine1:`تهدف نيسان إلى أن تكون كافة سياراتها الجديدة كليًا كهربائية في الأسواق الكبيرة بحلول العام ٢٠٣٠.`,
        copyNissanLine2:``,
      },
      message8:{
        copyUser:`أود بذل مجهود أكبر لإعادة تدوير مواد أكثر. فمراكز إعادة التدوير تتصرّف بأغراض تعجز مدينتي عن إعادة تدويرها. يؤدي ذلك إلى تقليل نسبة التلوث عبر تقليص الحاجة إلى تجميع مواد خام جديدة.`,
        copyNissan:`تركّز نيسان على عمليات إعادة التدوير ذات الحلقة المغلقة للفولاذ والألومنيوم والمواد الصمغية، وهي مواد رئيسية لتركيبة السيارة وإنما أثرها السلبي كبير على البيئة أيضًا.`,
        copyUserLine1:`أود بذل مجهود أكبر لإعادة تدوير مواد أكثر. فمراكز إعادة التدوير تتصرّف بأغراض تعجز مدينتي عن إعادة تدويرها.`,
        copyUserLine2:`يؤدي ذلك إلى تقليل نسبة التلوث عبر تقليص الحاجة إلى تجميع مواد خام جديدة.`,
        copyNissanLine1:`تركّز نيسان على عمليات إعادة التدوير ذات الحلقة المغلقة للفولاذ والألومنيوم والمواد الصمغية، وهي مواد رئيسية لتركيبة السيارة وإنما أثرها السلبي كبير على البيئة أيضًا.`,
        copyNissanLine2:``,
      },
      message9:{
        copyUser:`أريد تحسين جودة الهواء في منزلي عبر الحد من تعرّضي للمركّبات العضوية المتطايرة، والمواد الكيميائية الموجودة في العديد من المنتجات المستخدمة في بناء منازلنا وصيانتها. سأسعى مستقبلاً إلى شراء مواد طلاء وأثاث ذات نسب أقل من المركّبات العضوية المتطايرة.`,
        copyNissan:`طرحت نيسان في إطار عمليات تصنيعها خيارات طلاء ترتكز على الماء بتركيبتها ذات انبعاثات أقلّ من المركّبات العضوية المتطايرة، ومن شأنها تحسين معدلات إعادة تدوير مذيب الطلاء للحد من استخدامنا للمواد التي تنبعث منها المركّبات العضوية المتطايرة.`,
        copyUserLine1:`أريد تحسين جودة الهواء في منزلي عبر الحد من تعرّضي للمركّبات العضوية المتطايرة، والمواد الكيميائية الموجودة في العديد من المنتجات المستخدمة في بناء منازلنا وصيانتها.`,
        copyUserLine2:`سأسعى مستقبلاً إلى شراء مواد طلاء وأثاث ذات نسب أقل من المركّبات العضوية المتطايرة.`,
        copyNissanLine1:`طرحت نيسان في إطار عمليات تصنيعها خيارات طلاء ترتكز على الماء بتركيبتها ذات انبعاثات أقلّ من المركّبات العضوية المتطايرة، ومن شأنها تحسين معدلات إعادة تدوير مذيب الطلاء للحد من استخدامنا للمواد التي تنبعث منها المركّبات العضوية المتطايرة.`,
        copyNissanLine2:``,
      },
      message10:{
        copyUser:`أرغب بتخفيف تأثير أفراد أسرتي السلبي على مطامر النفايات. ومن الحلول التي يمكن اعتمادها لتحقيق ذلك هي التبرّع بالملابس المستخدمة بدلاً من التخلّص منها، وطلب تخفيف نسبة التغليف للمواد والأغراض التي نشتريها، وشراء المنتجات المصنوعة من مواد مُعاد تدويرها.`,
        copyNissan:`نجحت نيسان في خفض نسبة النفايات الناتجة عنها في المطامر بنسبة ٣.٤٪ عالميًا في السنة المالية ٢٠٢٠.`,
        copyUserLine1:`أرغب بتخفيف تأثير أفراد أسرتي السلبي على مطامر النفايات. `,
        copyUserLine2:`ومن الحلول التي يمكن اعتمادها لتحقيق ذلك هي التبرّع بالملابس المستخدمة بدلاً من التخلّص منها، وطلب تخفيف نسبة التغليف للمواد والأغراض التي نشتريها، وشراء المنتجات المصنوعة من مواد مُعاد تدويرها.`,
        copyNissanLine1:`نجحت نيسان في خفض نسبة النفايات الناتجة عنها في المطامر بنسبة ٣.٤٪ عالميًا في السنة المالية ٢٠٢٠.`,
        copyNissanLine2:``,
      },
      pattern1: {
        description:`نمط يشبه ريش السهم المتحرّك نحو الأمام؛ ويُمثّل التمنّي بالحظ السعيد للجميع.`,
      },
      pattern2: {
        description:`نمط يرمز إلى مدى قصر الحياة وجمالها؛ كما ترمز زهرة الكرز إلى البدايات الجديدة.`,
      },
      pattern3: {
        description:`يمثّل النمط القائم على الشكل السداسي الذي يشبه ورقة القنّب، النمو نظراً لأنّ نبات القنّب يدوم طويلاً وينمو بسرعة.`,
      },
      pattern4: {
        description:`نمط مستوحى من التصميم الموجود في سيارة آريا.`,
      },
      pattern5: {
        description:`نمط قائم على عناصر التصميم في سيارات نيسان Z الجديدة، يعتمد هذا النمط الهندسي نهج التكنولوجيا المتطوّرة.`,
      },
      pattern6:{
        description:`مستوحى من عنصر تصميم أساسي لفعالية مستقبل سيارات نيسان، إذ يعكس بتصميمه وأوزانه المختلفة إيقاعاً راقياً.`
      },
      share:{
        facebook:`نهدف ترك أثرنا عليك، وليس على البيئة. فقد نجحنا في الحدّ من بصمتنا الكربونية سعيًا إلى بلوغ هدفنا طويل الأمد المتمثل بتحقيق الحياد الكربوني.#Nissan #Expo2020 #OrigamiOfHope`,
        twitter:`حدّد هدفك المتعلّق بالحياد الكربوني وحقّقه.`
      },
    },
    ariya:{
      share:{
        twitter:`استمتع برحلة مفعمة بالإثارة والطاقة على متن نيسان آريا.
        #Nissan #Expo2020 #PowerAtPlay`,
        title:`قيادة سيارة آريا`,
        desc:` اشحن رحلتك بقيادة مفعمة بالإثارة والطاقة على متن نيسان آريا. استمتع بقيادة متقدّمة تكنولوجيًا ومنخفضة التوتر فيما تتغلّب على ظروف الطريق المختلفة، مما يجعل رحلتك أكثر أمانًا وسهولة مع تقنيات مساعدة السائق.
        #Nissan #Expo2020 #PowerAtPlay`,
      }
    }
  }
};

const I18nOriginal = createI18n(locales, translations);

function getPathName(locationOrLocale){
  if(typeof locationOrLocale === 'string'){
    return `/${locationOrLocale}`;
  }
  else if(typeof locationOrLocale === 'object' && locationOrLocale != null && 'pathname' in locationOrLocale){
    return locationOrLocale.pathname;
  }
  return undefined;
}

const I18n = (props) => {
  return <I18nOriginal {...props} />;
}

I18n.getTranslation = (locationOrLocale, key, args = {}) => {
  const pathname = getPathName(locationOrLocale);
  
  return I18nOriginal.getTranslation({pathname}, key, args);
};

export default I18n;
